import { SxProps } from '@mui/material';
import { black, black1, grey10, grey9 } from 'app/components/ThemeProvider/colors';
import { getTheme } from 'app/components/ThemeProvider/theme';

const theme = getTheme('light');

export const calculateBtn: SxProps = {
  display: 'flex',
  gap: '10px',
  minWidth: '40px',
  maxWidth: 'fit-content',
  height: '40px',
  p: '10px',

  '& .MuiSvgIcon-root': {
    width: '20px',
    height: '20px',
  },
};

export const expandBtn: SxProps = {
  height: '40px',
  p: '10px',
  width: '40px',
  minWidth: '40px',

  '& .MuiSvgIcon-root': {
    width: '20px',
    height: '20px',
  },
};

export const currencyBox = (expand: boolean) => ({
  display: 'flex',
  height: '72px',
  gap: '36px',
  padding: '14px 0',
  borderBottom: '1px solid #F3F4F6',

  [theme.breakpoints.down(1400)]: {
    gap: expand ? '16px' : '36px',
  },

  [theme.breakpoints.down('lg')]: {
    gap: '64px',
  },
  [theme.breakpoints.down('md')]: {
    gap: '56px',
  },
  [theme.breakpoints.down(640)]: {
    gap: '24px',
  },
  '&:last-child': {
    borderBottom: 'none',
    paddingBottom: '0',
    height: '58px',
  },
});

export const currencyInfoBox: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  justifyContent: 'space-between',
  mr: '30px',
  width: '60px',

  '&:last-child': {
    mr: 0,
    width: '96px',
  },
};

export const currencyInfoText: SxProps = { fontSize: '15px', color: '#14191F66', lineHeight: '1' };
export const currencyText: SxProps = { fontSize: '17px', color: black1, lineHeight: '1', fontWeight: '600' };

export const closeBtnBox: SxProps = {
  minWidth: '36px',
  height: '36px',
  p: '10px',
  background: grey10,
  borderRadius: '8px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '&:hover': {
    cursor: 'pointer',
  },

  '& .MuiSvgIcon-root': {
    width: '16px',
    height: '16px',
  },
};

export const selectBoxCurrency: SxProps = {
  display: 'flex',
  border: '1px solid rgba(20, 25, 31, 0.10)',
  borderRadius: '8px',
  alignItems: 'center',
  height: '48px',
};

export const switchBox: SxProps = {
  m: '0 auto 20px',
  width: '48px',
  height: '48px',
  borderRadius: '50%',
  background: grey9,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  '&:hover': {
    cursor: 'pointer',
    background: 'rgba(255, 199, 44, 0.85)',
  },
};

export const currencyUpdateInfoBox: SxProps = {
  background: grey10,
  borderRadius: '8px',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  p: '15px 16px',
};

export const calcModalPaper: SxProps = { p: '32px 36px', width: '400px' };

export const dialogTitleBox: SxProps = {
  display: 'flex',
  alignItems: 'center',
  p: '0',
  justifyContent: 'space-between',
  mb: '28px',
};

export const dialogTitle: SxProps = { fontSize: '22px', color: black, fontWeight: '600' };

export const calcSelectBox: SxProps = { display: 'flex', flexDirection: 'column', gap: '8px' };

export const calcLabel: SxProps = { fontSize: '15px', color: '#4D483B', lineHeight: 1 };

export const calcAmountInput: SxProps = {
  width: '100%',
  borderRight: 'none',
  '& fieldset': { border: 'none' },
};

export const currencyTextInfo: SxProps = { fontSize: '13px', color: 'rgba(20, 25, 31, 0.40)', lineHeight: '1' };

export const customStylesFlag = {
  control: (base: any, state: any) => ({
    ...base,
    height: '36px',
    border: 'none',
    width: '62px',

    boxShadow: state.isFocused ? null : null,
    '&:hover': {
      cursor: 'pointer',
    },
  }),

  container: (base: any) => ({
    ...base,
  }),
  menu: (base: any, state: any) => ({
    ...base,

    borderRadius: '8px',
    boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.06)',
    marginTop: 0,
    padding: 0,
    width: '300px',
    right: '0',
  }),
  menuList: (base: any) => ({
    ...base,

    padding: '16px 0',
    fontFamily: 'Yelo',
  }),

  valueContainer: (base: any, state: any) => ({
    ...base,
    padding: 0,
    margin: 0,
    background: 'transparent',
  }),

  singleValue: (base: any) => ({
    ...base,
    margin: 0,
    width: '26px',
    height: '17px',
  }),

  input: (base: any) => ({
    ...base,
    margin: 0,
    padding: 0,
    width: 0,
    height: 0,
  }),

  dropdownIndicator: (base: any, state: any) => ({
    ...base,
    padding: 0,
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
  }),

  option: (base: any, state: any) => ({
    ...base,
    color: black1,
    background: state.isSelected ? '#F3F4F6!important' : 'transparent',
    paddingLeft: '19px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    '&:hover': { background: '#F3F4F6!important', cursor: 'pointer' },
  }),

  menuPortal: (base: any) => ({ ...base, zIndex: '1000000' }),

  indicatorsContainer: (base: any) => ({ ...base, paddingRight: '8px' }),
};

export const customStylesCalc = {
  control: (base: any, state: any) => ({
    ...base,
    height: '46px',
    border: '1px solid rgba(20, 25, 31, 0.10)',
    borderRadius: '8px',

    boxShadow: state.isFocused ? null : null,
    '&:hover': {
      cursor: 'pointer',
    },
  }),

  container: (base: any) => ({
    ...base,
  }),
  menu: (base: any, state: any) => ({
    ...base,

    borderRadius: '8px',
    position: 'absolute',
    right: '1px',
    marginTop: 0,
    padding: 0,
    boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.06)',
  }),
  menuList: (base: any) => ({
    ...base,

    padding: '16px 0',
    fontFamily: 'Yelo',
  }),

  valueContainer: (base: any, state: any) => ({
    ...base,
    padding: 0,
    margin: 0,
    background: 'transparent',
    fontWeight: 500,
  }),

  singleValue: (base: any) => ({
    ...base,
    margin: 0,
    padding: '12px 16px',
    fontFamily: 'Yelo',
  }),

  input: (base: any) => ({
    ...base,
    margin: 0,
    padding: 0,
    width: 0,
    height: 0,
  }),

  dropdownIndicator: (base: any, state: any) => ({
    ...base,
    padding: 0,
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
  }),

  option: (base: any, state: any) => ({
    ...base,
    color: black1,
    background: state.isSelected ? '#F3F4F6!important' : 'transparent',
    paddingLeft: '19px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    '&:hover': { background: '#F3F4F6!important', cursor: 'pointer' },
  }),

  menuPortal: (base: any) => ({ ...base, zIndex: '1000000' }),

  indicatorsContainer: (base: any) => ({ ...base, paddingRight: '8px' }),
};
